module.exports = "/_next/static/images/pencil-line-0272f4ca6124fc91bb2b05bf1d7dd705.svg";